import { ImgHTMLAttributes } from 'react';
import { ImageUrlMap } from '../../mainv2/types/common';

export function expandImageParams(url: ImageUrlMap): ImgHTMLAttributes<HTMLImageElement> {
  if (url['1x'] && url['2x']) {
    return {
      src: url['1x'],
      srcSet: `${url['1x']} 1x, ${url['2x']} 2x`,
    };
  } else if (url['original']) {
    return {
      src: url['original'],
    };
  } else {
    return {};
  }
}
